import React from "react";
import { PageShell, Section } from "../components/landing/PageShell";
import { CONTACT_EMAIL, PRIVACY_DETAILS, PRIVACY_UPDATED } from "../data/site";

const EMAIL = "hello@sistersafe.app";

const withEmailLinks = (text) =>
  text.split(EMAIL).reduce((acc, part, i, arr) => {
    acc.push(<React.Fragment key={`t-${i}`}>{part}</React.Fragment>);
    if (i < arr.length - 1) {
      acc.push(
        <a
          key={`a-${i}`}
          href={`mailto:${EMAIL}`}
          className="font-medium text-[#2F5E43] underline decoration-[#2F5E43]/30 underline-offset-2 transition-colors hover:decoration-[#2F5E43]"
        >
          {EMAIL}
        </a>
      );
    }
    return acc;
  }, []);

export default function PrivacyPolicy() {
  return (
    <PageShell
      title="Privacy Policy"
      subtitle="Your safety and your privacy go hand in hand. This information explains what we collect, why, and the control you always have."
    >
      <p className="text-sm text-[#8AA583]" data-testid="privacy-page-last-updated">
        Last updated: {PRIVACY_UPDATED}
      </p>

      {PRIVACY_DETAILS.map((sec) => (
        <Section key={sec.heading} heading={sec.heading}>
          {sec.paragraphs.map((p, i) => (
            <p key={i}>{withEmailLinks(p)}</p>
          ))}
        </Section>
      ))}

      <Section heading="Contact Us">
        <p>
          If you have questions about this privacy information, your personal information,
          account deletion, or a privacy request, contact:
        </p>
        <p className="font-medium text-[#111E16]">SisterSafe</p>
        <p>
          Email:{" "}
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="font-medium text-[#2F5E43] underline decoration-[#2F5E43]/30 underline-offset-2 transition-colors hover:decoration-[#2F5E43]"
          >
            {CONTACT_EMAIL}
          </a>
        </p>
      </Section>
    </PageShell>
  );
}
